import { useAuthStore } from '../store/auth.store';

export async function apiFetch(
  path: string,
  init?: RequestInit,
): Promise<Response> {
  const token = useAuthStore.getState().sessionToken;
  const res = await fetch(path, {
    ...init,
    headers: {
      // Only when a body exists: Fastify rejects an empty body that claims to
      // be JSON, which breaks bodyless DELETEs.
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { 'x-session-token': token } : {}),
      ...(init?.headers ?? {}),
    },
  });

  if (res.status === 401) {
    useAuthStore.getState().clear();
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }

  return res;
}
